<template>
  <section class="StatusDisplayBar">
    <v-alert :value="hasError" type="error">
      <span v-if="typeof error === 'string'">
        {{ error }}
      </span>
      <ul v-else :class="error && error.length == 1 ? 'list-style-none' : ''">
        <li v-for="(err, errIndex) in error" :key="errIndex">
          {{ err }}
        </li>
      </ul>
    </v-alert>
    <v-alert :value="hasWarning" type="warning">
      <span v-if="typeof warnMessage === 'string'">
        {{ warnMessage }}
      </span>
      <ul v-else>
        <li v-for="(warn, warnIndex) in warnMessage" :key="warnIndex">
          {{ warn }}
        </li>
      </ul>
    </v-alert>
    <v-alert :value="hasWarningData" type="warning">
      <span>
        {{ warningText }}
      </span>
      <ul>
        <li v-for="(warn, warnDataIndex) in warningData" :key="warnDataIndex">
          {{ warn }}
        </li>
      </ul>
    </v-alert>
    <v-alert :value="hasSuccess" type="success">
      <slot name="SuccessMessage">
        {{ successMessage }}
      </slot>
    </v-alert>
    <v-alert v-if="hasLoadMessage" :value="loading" type="info">
      {{ loadingMessage }}
    </v-alert>
    <v-progress-linear v-if="loading" indeterminate color="success" />
  </section>
</template>

<script>
/**
 * This component is used to display a loading bar or error message,
 * typically to show that an API call is pending or problematic
 * "error" should be either the error message or "undefined"
 */
export default {
  name: 'StatusDisplayBar',
  props: {
    loading: {
      type: Boolean,
    },
    error: {
      type: [String, Array],
      default() {
        return undefined;
      },
    },
    loadingMessage: {
      type: String,
      default() {
        return undefined;
      },
    },
    warnMessage: {
      type: String,
      default() {
        return undefined;
      },
    },
    warningText: {
      type: String,
      default() {
        return undefined;
      },
    },
    warningData: {
      type: Array,
      default() {
        return [];
      },
    },
    successMessage: {
      type: String,
      default() {
        return undefined;
      },
    },
  },
  computed: {
    hasError() {
      if (this.error instanceof Array) {
        return this.error.length > 0;
      }
      return this.error !== undefined && this.error !== '';
    },
    hasWarning() {
      return this.warnMessage !== undefined && this.warnMessage !== '';
    },
    hasWarningData() {
      return (
        this.warningData !== undefined &&
        this.warningData.length !== 0 &&
        this.warningText !== undefined &&
        this.warningText !== ''
      );
    },
    hasLoadMessage() {
      return this.loadingMessage !== undefined && this.loadingMessage !== '';
    },
    hasSuccess() {
      return this.successMessage !== undefined && this.successMessage !== '';
    },
  },
};
</script>
<style>
.v-progress-linear,
.v-progress-linear__bar__indeterminate {
  border-radius: 6px;
}
.StatusDisplayBar {
  width: 100%;
}
.list-style-none {
  list-style: none;
  padding-left: 0;
}
</style>
